/*===================================
  #Product Order Swatches
  ================================*/
let selectedSwatchVariants = [];
const cartHolder = $('.ospc__holder');

document.addEventListener("DOMContentLoaded", function() {
  renderAllVariants();
  updateContinueButton();
});

function updateContinueButton() {
    const continueBtn = document.getElementById('swatch-continue-btn');
    if (continueBtn) {
        continueBtn.disabled = selectedSwatchVariants.length === 0;
    }
}

$(document).on('click', '.osps__atc', function(){

    let vObject = $(this).data('variant-info');

    if (vObject) {

        const existingIndex = selectedSwatchVariants.findIndex(variant => variant.id === vObject.id);
        
        if (existingIndex !== -1) {
            $(this).find('.plus').removeClass('hidden');
            $(this).find('.minus').addClass('hidden');

            selectedSwatchVariants.splice(existingIndex, 1);
            
            cartHolder.find(`[data-variant-id="${vObject.id}"]`).remove();
            
            if (selectedSwatchVariants.length === 0) {
                cartHolder.html('<p class="mt-4 fs-4">Select Your Swatches</p>');
            }
            
        } else { 
            if(selectedSwatchVariants.length < 10){
                $(this).find('.plus').addClass('hidden');
                $(this).find('.minus').removeClass('hidden');

                if (cartHolder.find('p').length > 0) {
                    cartHolder.find('p').remove(); 
                }
                
                selectedSwatchVariants.push(vObject);
                
                appendVariant(vObject);
            }else{
                alert('You have reached the maximum of 10 swatches.');
            }
        }
        
        console.log('Selected Variants:', selectedSwatchVariants);
        updateContinueButton();
    } else {
        console.error('Error: Variant data could not be retrieved.');
    }
});


$(document).on('click', '.remove-from-cart', function() {
    const variantId = $(this).closest('.selected-item').data('variant-id');
    const existingIndex = selectedSwatchVariants.findIndex(variant => variant.id === variantId);

    if (existingIndex !== -1) {
        
        selectedSwatchVariants.splice(existingIndex, 1);

        
        $(this).closest('.selected-item').remove();

        
        const originalSwatch = $(`[data-variant-id="${variantId}"]`);
        originalSwatch.find('.plus').removeClass('hidden');
        originalSwatch.find('.minus').addClass('hidden');

        
        if (selectedSwatchVariants.length === 0) {
            cartHolder.html('<p class="mt-4 fs-4">Select Your Swatches</p>');
        }
        updateContinueButton();
    }
});

$(document).on('click', '.continue_button .btn', function() {
    if (selectedSwatchVariants.length === 0) {
        alert('Please select at least one swatch.');
    } 
    else if (selectedSwatchVariants.length > 10){
        alert('You can only have a maximum of 10 swatches.');
    }
    else {
      fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }        
      })
      .then(response => response.json())
      .then(data => {
        console.log('cart data',data);
        if (data.item_count === 0){
          //cart is empty, can add swatches
          addSwatchesToCart(selectedSwatchVariants);
        }
        else{
          // Check if cart contains non-swatch items
          const hasNonSwatchItems = data.items.some(item => item.product_type !== 'Swatch');
          
          if (hasNonSwatchItems) {
            // Cart has non-swatch products, show modal with notice
            const swatchNoticeModal = new bootstrap.Modal(document.getElementById('swatchNoticeModal'));
            const modalBodyText = 'Swatches cannot be ordered with other products. To order swatches, please remove all other items from your cart and complete the checkout.';
            document.querySelector('#swatchNoticeModal .modal-body--text').innerHTML = modalBodyText;
            swatchNoticeModal.show();
          }
          else {
            // Cart only has swatches, clear and add new ones
            fetch(window.Shopify.routes.root + 'cart/clear.js', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }        
            })
            .then(response => response.json())
            .then(data => {
              console.log('cart cleared',data);
              addSwatchesToCart(selectedSwatchVariants);
            })
            .catch(error => {
              console.error(error);
            });
          }
        }        
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle error
        $("#AddToCartErr .modal-title").html(error.message);
        $("#AddToCartErr .modal-body").html(error.description);
        $("#cart-overlay").fadeOut();
        modal.show();
      });
    }
});

function cartContainsProductType(cart, productType) {
  return cart.items.some(item => item.product_type === productType);
}

function cartDoesNotContainProductType(cart, productType) {
  return cart.items.some(item => item.product_type !== productType);
}

function appendVariant(variant){
  const variantHtml = `
    <div class="selected-item d-flex align-items-center mb-2 mt-3 position-relative" data-variant-id="${variant.id}">
        <img src="${variant.featured_image.src}" alt="${variant.title}" style="width: 50px; height: 50px; margin-right:20px;"><span>${variant.title}</span>
        <span class="remove-from-cart end-0 position-absolute" style="cursor:pointer;">
           <svg width="24px" height="24px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" d="M12.78 4.28a.75.75 0 00-1.06-1.06L8 6.94 4.28 3.22a.75.75 0 00-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 101.06 1.06L8 9.06l3.72 3.72a.75.75 0 101.06-1.06L9.06 8l3.72-3.72z"/></svg>
        </span>
    </div>`;

    cartHolder.append(variantHtml);
}

function renderAllVariants(){
  cartHolder.empty(); 
  cartHolder.html('<p class="mt-4 fs-4">Select Your Swatches</p>');
}

function addSwatchesToCart(swatchVariants) {

  $("#cart-overlay").show();

  let formData = {
      'items': []
  };

  swatchVariants.forEach(variant => {
    formData.items.push({
      'id': variant.id,
      'quantity': 1
    });
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
  })
  .then(response => {
      console.log('atc response', response)
      if (!response.ok) {
          const error = new Error('Failed to add product to cart');
          error.description = response.statusText;
          throw error;
      }
      return response.json();
  })
  .then(() => {
      document.body.dispatchEvent(new CustomEvent('requestCartUpdate'));
  })
  .catch((error) => {
      console.error('Error:', error);
      // Handle error
      console.error('Cart error:', error.message, error.description);
      $("#cart-overlay").fadeOut();
      alert('Error: ' + error.message);
  });
}